import React from 'react';
import PropTypes from 'prop-types';
import { Carousel, CtaButton, ResponsiveImage } from '../../molecules';
import { Endorsement } from './Endorsement';
import {
  EndorsementsOutsideContainer,
  Headline,
  Buttons,
  ImageButton,
  GetStartedContainer,
} from './styles';

export const Endorsements = ({ headline, endorsements, link }) => {
  return (
    <EndorsementsOutsideContainer>
      <Headline>{headline}</Headline>
      <Carousel
        itemsToShow={1}
        showArrows={false}
        renderPagination={({ activePage, onClick }) => (
          <Buttons>
            {endorsements.map((e, i) => {
              const isActivePage = activePage === i;
              return (
                <ImageButton
                  aria-label={e.name}
                  aria-pressed={isActivePage}
                  activePage={isActivePage}
                  type="button"
                  onClick={() => onClick(i)}
                  key={i}
                >
                  <ResponsiveImage {...e.photo} objectFit="cover" />
                </ImageButton>
              );
            })}
          </Buttons>
        )}
      >
        {endorsements.map(e => (
          <Endorsement {...e} key={e.name} />
        ))}
      </Carousel>
      {link && (
        <GetStartedContainer>
          <CtaButton variant="spinach" href={link.target}>
            {link.text}
          </CtaButton>
        </GetStartedContainer>
      )}
    </EndorsementsOutsideContainer>
  );
};

Endorsements.displayName = 'Endorsements';

Endorsements.propTypes = {
  headline: PropTypes.string.isRequired,
  endorsements: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      photo: PropTypes.object.isRequired,
    }),
  ).isRequired,
  link: PropTypes.shape({
    target: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
};
